import React, { Component } from 'react';
import '../App.css';
import { render } from '@testing-library/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import firebaseConfig from "../config"
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

firebase.analytics();

class Naruto extends Component{
state={
  boucle: 1,
  etape: 1,
  result: null

}

connexion = e =>{

  var provider = new firebase.auth.TwitterAuthProvider();
  firebase.auth().languageCode = 'fr';
// To apply the default browser preference instead of explicitly setting it.
// firebase.auth().useDeviceLanguage();
provider.setCustomParameters({
  'lang': 'fr'
});


firebase.auth().signInWithPopup(provider).then((result) => {
  // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
  // You can use these server side with your app's credentials to access the Twitter API.
  var token = result.credential.accessToken;
  var secret = result.credential.secret;
  // The signed-in user info.
  var user = result.user;
  






  this.setState({
    etape: 2
  })


}).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // The email of the user's account used.
  var email = error.email;
  // The firebase.auth.AuthCredential type that was used.
  var credential = error.credential;
  // ...
});


}

deco = e =>{
  firebase.auth().signOut().then(() => {
    
    document.location.reload(true)

  }).catch(function(error) {
    // An error happened.
  });
}

componentDidMount(){




  firebase.auth().onAuthStateChanged((user) => {
    if (user) {

      var rudy = Math.floor((Math.random() * Math.floor(21))+1)
      this.setState({
        etape: 2,
        result: rudy
      })

    } else {
      // No user is signed in.
    }
  });




  setInterval(() => {
      
    var rudy = Math.floor((Math.random() * Math.floor(21))+1)

    this.setState({
      boucle: rudy
    })

  }, 800);



}

resultatco = e =>{
    this.setState({
        etape: 3
    })
}



  render(){


    var NomDuPerso


    if(this.state.result == 1){NomDuPerso = "Danzo"}
    if(this.state.result == 2){NomDuPerso = "Gaara"}
    if(this.state.result == 3){NomDuPerso = "Gai"}
    if(this.state.result == 4){NomDuPerso = "Hinata"}
    if(this.state.result == 5){NomDuPerso = "Itachi"}
    if(this.state.result == 6){NomDuPerso = "Jiraiya"}
    if(this.state.result == 7){NomDuPerso = "kakashi"}
    if(this.state.result == 8){NomDuPerso = "Karin"}
    if(this.state.result == 9){NomDuPerso = "Kiba"}
    if(this.state.result == 10){NomDuPerso = "Madara"}
    if(this.state.result == 11){NomDuPerso = "Minato"}
    if(this.state.result == 12){NomDuPerso = "Nagato"}
    if(this.state.result == 13){NomDuPerso = "Naruto"}
    if(this.state.result == 14){NomDuPerso = "Neji"}
    if(this.state.result == 15){NomDuPerso = "Pain"}
    if(this.state.result == 16){NomDuPerso = "RockLee"}
    if(this.state.result == 17){NomDuPerso = "Saï"}
    if(this.state.result == 18){NomDuPerso = "Sakura"}
    if(this.state.result == 19){NomDuPerso = "Sasuke"}
    if(this.state.result == 20){NomDuPerso = "Shikamaru"}
    if(this.state.result == 21){NomDuPerso = "Tsunade"}



  return (
    <div><div className="container">
      <a  href="/" >
      <img className="logosite" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/logo%2Fblack.png?alt=media&token=dd05b239-fb5c-45fe-b7c5-cd2e4e0fe953"></img>
      </a>
      <h3 className="titleprincipal">Quel personnage de Naruto es-tu ?</h3>

{this.state.etape == 1 && <div>

      {/* Boucle qui montre les persos qui peuvent être choisi */}
      <div className="boucleimg"> 
        {this.state.boucle == 1 && <img className="photoboucleimg" id="Danzo" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/danzo.png?alt=media&token=f0c18f30-d98b-429d-93f7-c0a154123b0b"></img>}
        {this.state.boucle == 2 && <img className="photoboucleimg" id="Gaara" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Gaara.png?alt=media&token=f30a8411-b305-4a09-aea1-eac440552a53"></img>}
        {this.state.boucle == 3 && <img className="photoboucleimg" id="Gai" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Gai.png?alt=media&token=629ff8b8-a39b-4747-81d9-fce14feda801"></img>}
        {this.state.boucle == 4 && <img className="photoboucleimg" id="Hinata" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Inata.png?alt=media&token=8c8e6d6f-cc91-4fda-a243-cecfdc7be758"></img>}
        {this.state.boucle == 5 && <img className="photoboucleimg" id="Itachi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Itachi.png?alt=media&token=2fc94f62-ae14-4c74-b7fe-09bef4d3b090"></img>}
        {this.state.boucle == 6 && <img className="photoboucleimg" id="Jiraiya" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Jiraiya.png?alt=media&token=8dc4543e-abb8-413e-a57b-53f58769b9bd"></img>}
        {this.state.boucle == 7 && <img className="photoboucleimg" id="kakashi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Kakashi.png?alt=media&token=f32f4946-bb27-4312-9904-15de995229a0"></img>}
        {this.state.boucle == 8 && <img className="photoboucleimg" id="Karin" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Karin.png?alt=media&token=06dbb267-f8c5-4f7e-aa8d-852974e0d9a9"></img>}
        {this.state.boucle == 9 && <img className="photoboucleimg" id="Kiba" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Kiba.png?alt=media&token=76bfae35-f3b6-45af-b9f7-b08ccc7079cf"></img>}
        {this.state.boucle == 10 && <img className="photoboucleimg" id="Madara" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Madara.png?alt=media&token=483a4f84-d1b4-4595-80bc-544bd6448758"></img>}
        {this.state.boucle == 11 && <img className="photoboucleimg" id="Minato" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Minato.png?alt=media&token=8dfe23d2-17cb-49da-ae45-04b8eb193a09"></img>}
        {this.state.boucle == 12 && <img className="photoboucleimg" id="Nagato" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Nagato.png?alt=media&token=73a330b1-e670-4645-9bdf-207e26461feb"></img>}
        {this.state.boucle == 13 && <img className="photoboucleimg" id="Naruto" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Naruto.png?alt=media&token=cf3daba6-f80b-46c4-8a61-6b54d04cf2d5"></img>}
        {this.state.boucle == 14 && <img className="photoboucleimg" id="Neji" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Neji.png?alt=media&token=1b5e2bb1-dd2f-4c48-a860-b687d0a1132d"></img>}
        {this.state.boucle == 15 && <img className="photoboucleimg" id="Pain" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/pain.png?alt=media&token=8a9ee048-ecd6-427c-97da-14582667b51d"></img>}
        {this.state.boucle == 16 && <img className="photoboucleimg" id="RockLee" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/rockleee.png?alt=media&token=f1b44cef-f14a-4783-bdf5-6b6655e83656"></img>}
        {this.state.boucle == 17 && <img className="photoboucleimg" id="Saï" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sa%C3%AF.png?alt=media&token=9496dfb3-bef3-4b4c-ae6e-f0a3a43c50da"></img>}
        {this.state.boucle == 18 && <img className="photoboucleimg" id="Sakura" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sakura.png?alt=media&token=a5572893-90bd-4584-9622-7b09903e397c"></img>}
        {this.state.boucle == 19 && <img className="photoboucleimg" id="Sasuke" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sasuke.png?alt=media&token=a834e281-d092-4309-bb8d-be0a80382800"></img>}
        {this.state.boucle == 20 && <img className="photoboucleimg" id="Shikamaru" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Shikamaru.png?alt=media&token=6ae65def-f3a6-4fe0-85d1-7d6984125b07"></img>}
        {this.state.boucle == 21 && <img className="photoboucleimg" id="Tsudane" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sunade.png?alt=media&token=42cc1ba5-705c-4c5b-ad34-796bbd0954d5"></img>}
        {/* {this.state.boucle == 7 && <img id="Gaara" src="#"></img>} */}
      </div>


      <button className="button_connexion" onClick={this.connexion}><img className="twitterlogobutton" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/twitter_PNG15.png?alt=media&token=5e474f5f-f84f-45a6-aa12-d4ad05f6d021"></img>Connexion avec Twitter</button>
</div>}




{this.state.etape == 2 && <div>

    <button className="button_connexion" onClick={this.resultatco}>Découvrir le résultat !</button>
    <p className="manquement">Tu es connecté via Twitter, <a href='#' onClick={this.deco}>Deconnexion</a></p>


                            </div>}



    {this.state.etape == 3 && <div>

  <div className="boucleimg">
        {this.state.result == 1 && <img className="photoboucleimg" id="Danzo" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/danzo.png?alt=media&token=f0c18f30-d98b-429d-93f7-c0a154123b0b"></img>}
        {this.state.result == 2 && <img className="photoboucleimg" id="Gaara" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Gaara.png?alt=media&token=f30a8411-b305-4a09-aea1-eac440552a53"></img>}
        {this.state.result == 3 && <img className="photoboucleimg" id="Gai" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Gai.png?alt=media&token=629ff8b8-a39b-4747-81d9-fce14feda801"></img>}
        {this.state.result == 4 && <img className="photoboucleimg" id="Hinata" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Inata.png?alt=media&token=8c8e6d6f-cc91-4fda-a243-cecfdc7be758"></img>}
        {this.state.result == 5 && <img className="photoboucleimg" id="Itachi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Itachi.png?alt=media&token=2fc94f62-ae14-4c74-b7fe-09bef4d3b090"></img>}
        {this.state.result == 6 && <img className="photoboucleimg" id="Jiraiya" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Jiraiya.png?alt=media&token=8dc4543e-abb8-413e-a57b-53f58769b9bd"></img>}
        {this.state.result == 7 && <img className="photoboucleimg" id="kakashi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Kakashi.png?alt=media&token=f32f4946-bb27-4312-9904-15de995229a0"></img>}
        {this.state.result == 8 && <img className="photoboucleimg" id="Karin" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Karin.png?alt=media&token=06dbb267-f8c5-4f7e-aa8d-852974e0d9a9"></img>}
        {this.state.result == 9 && <img className="photoboucleimg" id="Kiba" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Kiba.png?alt=media&token=76bfae35-f3b6-45af-b9f7-b08ccc7079cf"></img>}
        {this.state.result == 10 && <img className="photoboucleimg" id="Madara" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Madara.png?alt=media&token=483a4f84-d1b4-4595-80bc-544bd6448758"></img>}
        {this.state.result == 11 && <img className="photoboucleimg" id="Minato" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Minato.png?alt=media&token=8dfe23d2-17cb-49da-ae45-04b8eb193a09"></img>}
        {this.state.result == 12 && <img className="photoboucleimg" id="Nagato" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Nagato.png?alt=media&token=73a330b1-e670-4645-9bdf-207e26461feb"></img>}
        {this.state.result == 13 && <img className="photoboucleimg" id="Naruto" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Naruto.png?alt=media&token=cf3daba6-f80b-46c4-8a61-6b54d04cf2d5"></img>}
        {this.state.result == 14 && <img className="photoboucleimg" id="Neji" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Neji.png?alt=media&token=1b5e2bb1-dd2f-4c48-a860-b687d0a1132d"></img>}
        {this.state.result == 15 && <img className="photoboucleimg" id="Pain" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/pain.png?alt=media&token=8a9ee048-ecd6-427c-97da-14582667b51d"></img>}
        {this.state.result == 16 && <img className="photoboucleimg" id="RockLee" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/rockleee.png?alt=media&token=f1b44cef-f14a-4783-bdf5-6b6655e83656"></img>}
        {this.state.result == 17 && <img className="photoboucleimg" id="Saï" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sa%C3%AF.png?alt=media&token=9496dfb3-bef3-4b4c-ae6e-f0a3a43c50da"></img>}
        {this.state.result == 18 && <img className="photoboucleimg" id="Sakura" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sakura.png?alt=media&token=a5572893-90bd-4584-9622-7b09903e397c"></img>}
        {this.state.result == 19 && <img className="photoboucleimg" id="Sasuke" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sasuke.png?alt=media&token=a834e281-d092-4309-bb8d-be0a80382800"></img>}
        {this.state.result == 20 && <img className="photoboucleimg" id="Shikamaru" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Shikamaru.png?alt=media&token=6ae65def-f3a6-4fe0-85d1-7d6984125b07"></img>}
        {this.state.result == 21 && <img className="photoboucleimg" id="Tsudane" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/Sunade.png?alt=media&token=42cc1ba5-705c-4c5b-ad34-796bbd0954d5"></img>}
 </div>       

    <h5 className="text_result">Tu es {NomDuPerso} !</h5>
    <p className="titleshare">Prends une capture et partage-le dès maintenant sur Twitter !</p>

<div className="centerContent">
<div className="selfCenter">
<TwitterShareButton url="https://bit.ly/2BX72Ce" 

options={{
    text: `Je suis ${NomDuPerso} dans Naruto🍥 ! Tu peux essayer ici:`,
    size: 'large',
    via: 'dyrudyru',
  }} placeholder={<div />} />
</div>
</div>


    <p className="manquement">Il manque un personnage que vous aimez? <a href="https://twitter.com/messages/compose?recipient_id=1072970252298915842">Dites-le moi !</a></p>

<a href="#" className="deco" onClick={this.deco}>Deconnexion</a>


    </div>}
    </div>

    </div>
  )}
}

export default Naruto;
